import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "dw-module-list" }
const _hoisted_2 = { class: "dw-explorer-list" }
const _hoisted_3 = {
  key: 0,
  cellpadding: "0",
  cellspacing: "0",
  class: "item-list",
  style: {"max-width":"600px"}
}
const _hoisted_4 = { class: "tbody" }
const _hoisted_5 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_6 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_7 = { class: "item" }
const _hoisted_8 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_9 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_10 = { class: "item" }
const _hoisted_11 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_12 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_13 = { class: "item" }
const _hoisted_14 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_15 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_16 = { class: "item" }
const _hoisted_17 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_18 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_19 = { class: "item" }
const _hoisted_20 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_21 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_22 = { class: "item" }
const _hoisted_23 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_24 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_25 = { class: "item" }
const _hoisted_26 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_27 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_28 = { class: "item" }
const _hoisted_29 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_30 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_31 = { class: "item" }
const _hoisted_32 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_33 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_34 = { class: "item" }
const _hoisted_35 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_36 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_37 = { class: "item" }
const _hoisted_38 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_39 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_40 = { class: "item" }
const _hoisted_41 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_42 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_43 = { class: "item" }
const _hoisted_44 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_45 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_46 = { class: "item" }
const _hoisted_47 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_48 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_49 = { class: "item" }
const _hoisted_50 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_51 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_52 = { class: "item" }
const _hoisted_53 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_54 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_55 = { class: "item" }
const _hoisted_56 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_57 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_58 = { class: "item" }
const _hoisted_59 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_60 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_61 = { class: "item" }
const _hoisted_62 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_63 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_64 = { class: "item" }
const _hoisted_65 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_66 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_67 = { class: "item" }
const _hoisted_68 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_69 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_70 = { class: "item" }
const _hoisted_71 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_72 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_73 = { class: "item" }
const _hoisted_74 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_75 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_76 = { class: "item" }
const _hoisted_77 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_78 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_79 = { class: "item" }
const _hoisted_80 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_81 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_82 = { class: "item" }
const _hoisted_83 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_84 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_85 = { class: "item" }
const _hoisted_86 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_87 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_88 = { class: "item" }
const _hoisted_89 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_90 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_91 = { class: "item" }
const _hoisted_92 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_93 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_94 = { class: "item" }
const _hoisted_95 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_96 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_97 = { class: "item" }
const _hoisted_98 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_99 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_100 = { class: "item" }
const _hoisted_101 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_102 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_103 = { class: "item" }
const _hoisted_104 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_105 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_106 = { class: "item" }
const _hoisted_107 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_108 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_109 = { class: "item" }
const _hoisted_110 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_111 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_112 = { class: "item" }
const _hoisted_113 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_114 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_115 = { class: "item" }
const _hoisted_116 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_117 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_118 = { class: "item" }
const _hoisted_119 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_120 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_121 = { class: "item" }
const _hoisted_122 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_123 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_124 = { class: "item" }
const _hoisted_125 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_126 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_127 = { class: "item" }
const _hoisted_128 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_129 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_130 = { class: "item" }
const _hoisted_131 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_132 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_133 = { class: "item" }
const _hoisted_134 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_135 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_136 = { class: "item" }
const _hoisted_137 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_138 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_139 = { class: "item" }
const _hoisted_140 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_141 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_142 = { class: "item" }
const _hoisted_143 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_144 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_145 = { class: "item" }
const _hoisted_146 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_147 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_148 = { class: "item" }
const _hoisted_149 = {
  class: "row",
  "data-hover": "true",
  "data-cursor": "default",
  "data-border": "true"
}
const _hoisted_150 = {
  class: "cel",
  "data-align": "right"
}
const _hoisted_151 = { class: "item" }

import { ref, computed, watch, onBeforeMount } from "vue";
import { useStore } from "vuex";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'ModuleDeviceTelemetry',
  setup(__props, { expose: __expose }) {

__expose({ getModuleData });

const store = useStore();

const realTimeData = ref<any>(null);
const validationErrors = ref<any[]>([]);
const realTimeNav = ref<string | null>(null);
const realTimeDataInterval = ref<any>(null);

const navigationContext = computed(() => {
    return store.getters["navigationStore/navigationContext"];
});

const itemIdMaster = computed(() => {
    return store.getters["itemStore/itemIdMaster"];
});

watch(navigationContext, () => {
    getData();
});

onBeforeMount(async () => {
    await getData();

    setRealTimeDataInterval();
});

async function getData() {
    validationErrors.value = [];

    try {
        let response = await Axios.post("/dataweb/api/module/moduledevicetelemetry/getdata?nav=" + navigationContext.value.nav);

        realTimeData.value = response.data.realTimeData;
    } catch (error) {
        if (error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
}

function setRealTimeDataInterval() {
    realTimeNav.value = navigationContext.value.nav;
    const interval = 5 * 1000; // 5 seconds
    realTimeDataInterval.value = setInterval(function () {
        if (navigationContext.value.nav != realTimeNav.value) {
            clearInterval(realTimeDataInterval.value);
        } else {
            getData();
        }
    }, interval);
}

function getModuleData() {
    let moduleData = { isCompleted: true };
    return moduleData;
}

function formatDateTimeOffset(dateItem: string): string {
    if (dateItem == null) {
        return "";
    }

    let date = new Date(dateItem);
    return date.toLocaleString((<any>window).App.userCulture, {
        day: "numeric",
        month: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit"
    });
}

function formatSeconds(seconds: number): string {
    let hours: any = Math.floor(seconds / 3600);
    let minutes: any = Math.floor((seconds - (hours * 3600)) / 60);

    if (hours < 10) { hours = "0" + hours; }
    if (minutes < 10) { minutes = "0" + minutes; }
    return hours + ":" + minutes;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        (realTimeData.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
              _cache[49] || (_cache[49] = _createElementVNode("thead", { class: "header" }, [
                _createElementVNode("tr", {
                  class: "row",
                  "data-border": "true"
                }, [
                  _createElementVNode("td", { class: "cel" }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Parametro")
                    ])
                  ]),
                  _createElementVNode("td", {
                    class: "cel",
                    "data-align": "right"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Valore")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("tbody", _hoisted_4, [
                _createElementVNode("tr", _hoisted_5, [
                  _cache[0] || (_cache[0] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Timestamp")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(formatDateTimeOffset(realTimeData.value.timestamp)), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_8, [
                  _cache[1] || (_cache[1] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Sofware_Version")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, _toDisplayString(realTimeData.value.sofware_Version), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_11, [
                  _cache[2] || (_cache[2] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "MAC_Address")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(realTimeData.value.maC_Address), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_14, [
                  _cache[3] || (_cache[3] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Machine_Time")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(formatSeconds(realTimeData.value.machine_Time)), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_17, [
                  _cache[4] || (_cache[4] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Therapy_Time_Main")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, _toDisplayString(formatSeconds(realTimeData.value.therapy_Time_Main)), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_20, [
                  _cache[5] || (_cache[5] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Therapy_Time_Side")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, _toDisplayString(formatSeconds(realTimeData.value.therapy_Time_Side)), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_23, [
                  _cache[6] || (_cache[6] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Machine_Status")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, _toDisplayString(realTimeData.value.machine_Status), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_26, [
                  _cache[7] || (_cache[7] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Use_Mode")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, _toDisplayString(realTimeData.value.use_Mode), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_29, [
                  _cache[8] || (_cache[8] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Optical_Peak_Power")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(realTimeData.value.optical_Peak_Power) + " W", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_32, [
                  _cache[9] || (_cache[9] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Optical_Avg_Power")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, _toDisplayString(realTimeData.value.optical_Avg_Power) + " W", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_35, [
                  _cache[10] || (_cache[10] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Elect_Peak_Power")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, _toDisplayString(realTimeData.value.elect_Peak_Power) + " VA", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_38, [
                  _cache[11] || (_cache[11] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Elect_Avg_Power")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, _toDisplayString(realTimeData.value.elect_Avg_Power) + " VA", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_41, [
                  _cache[12] || (_cache[12] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Shot_Energy")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_42, [
                    _createElementVNode("div", _hoisted_43, _toDisplayString(realTimeData.value.shot_Energy) + " mJ", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_44, [
                  _cache[13] || (_cache[13] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Flow_Power")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, _toDisplayString(realTimeData.value.flow_Power), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_47, [
                  _cache[14] || (_cache[14] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Flow_Mode")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_48, [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(realTimeData.value.flow_Mode), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_50, [
                  _cache[15] || (_cache[15] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Emission_Mode")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, _toDisplayString(realTimeData.value.emission_Mode), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_53, [
                  _cache[16] || (_cache[16] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Working_Mode")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_54, [
                    _createElementVNode("div", _hoisted_55, _toDisplayString(realTimeData.value.working_Mode), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_56, [
                  _cache[17] || (_cache[17] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Avx_Mode")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_57, [
                    _createElementVNode("div", _hoisted_58, _toDisplayString(realTimeData.value.avx_Mode), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_59, [
                  _cache[18] || (_cache[18] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Frequency")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_60, [
                    _createElementVNode("div", _hoisted_61, _toDisplayString(realTimeData.value.frequency) + " Hz", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_62, [
                  _cache[19] || (_cache[19] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Emitted_Energy")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_63, [
                    _createElementVNode("div", _hoisted_64, _toDisplayString(realTimeData.value.emitted_Energy) + " J", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_65, [
                  _cache[20] || (_cache[20] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Emitted_Shots")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, _toDisplayString(realTimeData.value.emitted_Shots), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_68, [
                  _cache[21] || (_cache[21] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Machine")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_69, [
                    _createElementVNode("div", _hoisted_70, _toDisplayString(realTimeData.value.t_Machine) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_71, [
                  _cache[22] || (_cache[22] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_App_Main")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_72, [
                    _createElementVNode("div", _hoisted_73, _toDisplayString(realTimeData.value.t_App_Main) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_74, [
                  _cache[23] || (_cache[23] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_App_Side")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_75, [
                    _createElementVNode("div", _hoisted_76, _toDisplayString(realTimeData.value.t_App_Side) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_77, [
                  _cache[24] || (_cache[24] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Handpiece")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_78, [
                    _createElementVNode("div", _hoisted_79, _toDisplayString(realTimeData.value.t_Handpiece) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_80, [
                  _cache[25] || (_cache[25] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_1")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, _toDisplayString(realTimeData.value.t_Probe_1) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_83, [
                  _cache[26] || (_cache[26] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_2")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_84, [
                    _createElementVNode("div", _hoisted_85, _toDisplayString(realTimeData.value.t_Probe_2) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_86, [
                  _cache[27] || (_cache[27] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_3")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_87, [
                    _createElementVNode("div", _hoisted_88, _toDisplayString(realTimeData.value.t_Probe_3) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_89, [
                  _cache[28] || (_cache[28] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_4")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_90, [
                    _createElementVNode("div", _hoisted_91, _toDisplayString(realTimeData.value.t_Probe_4) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_92, [
                  _cache[29] || (_cache[29] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_5")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, _toDisplayString(realTimeData.value.t_Probe_5) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_95, [
                  _cache[30] || (_cache[30] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_6")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_96, [
                    _createElementVNode("div", _hoisted_97, _toDisplayString(realTimeData.value.t_Probe_6) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_98, [
                  _cache[31] || (_cache[31] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "T_Probe_7")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_99, [
                    _createElementVNode("div", _hoisted_100, _toDisplayString(realTimeData.value.t_Probe_7) + " °C", 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_101, [
                  _cache[32] || (_cache[32] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Bypass_Handpiece")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_102, [
                    _createElementVNode("div", _hoisted_103, _toDisplayString(realTimeData.value.bypass_Handpiece), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_104, [
                  _cache[33] || (_cache[33] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Main_Accessory")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_105, [
                    _createElementVNode("div", _hoisted_106, _toDisplayString(realTimeData.value.main_Accessory), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_107, [
                  _cache[34] || (_cache[34] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Side_Accessory")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, _toDisplayString(realTimeData.value.side_Accessory), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_110, [
                  _cache[35] || (_cache[35] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Serial_Num_Handpiece")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_111, [
                    _createElementVNode("div", _hoisted_112, _toDisplayString(realTimeData.value.serial_Num_Handpiece), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_113, [
                  _cache[36] || (_cache[36] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Shots_Handpiece")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, _toDisplayString(realTimeData.value.shots_Handpiece), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_116, [
                  _cache[37] || (_cache[37] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Interlock")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_117, [
                    _createElementVNode("div", _hoisted_118, _toDisplayString(realTimeData.value.interlock), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_119, [
                  _cache[38] || (_cache[38] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Footswitch")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_120, [
                    _createElementVNode("div", _hoisted_121, _toDisplayString(realTimeData.value.footswitch), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_122, [
                  _cache[39] || (_cache[39] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Fingerswitch")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, _toDisplayString(realTimeData.value.fingerswitch), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_125, [
                  _cache[40] || (_cache[40] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Patient_Button")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_126, [
                    _createElementVNode("div", _hoisted_127, _toDisplayString(realTimeData.value.patient_Button), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_128, [
                  _cache[41] || (_cache[41] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Coupling")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, _toDisplayString(realTimeData.value.coupling), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_131, [
                  _cache[42] || (_cache[42] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Water_Tank_Pres")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_132, [
                    _createElementVNode("div", _hoisted_133, _toDisplayString(realTimeData.value.water_Tank_Pres), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_134, [
                  _cache[43] || (_cache[43] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Water_Tank_Full")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_135, [
                    _createElementVNode("div", _hoisted_136, _toDisplayString(realTimeData.value.water_Tank_Full), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_137, [
                  _cache[44] || (_cache[44] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Compressor_Status")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, _toDisplayString(realTimeData.value.compressor_Status), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_140, [
                  _cache[45] || (_cache[45] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Precooling")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_141, [
                    _createElementVNode("div", _hoisted_142, _toDisplayString(realTimeData.value.precooling), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_143, [
                  _cache[46] || (_cache[46] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Defrost")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_144, [
                    _createElementVNode("div", _hoisted_145, _toDisplayString(realTimeData.value.defrost), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_146, [
                  _cache[47] || (_cache[47] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Battery_Status")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_147, [
                    _createElementVNode("div", _hoisted_148, _toDisplayString(realTimeData.value.battery_Status), 1)
                  ])
                ]),
                _createElementVNode("tr", _hoisted_149, [
                  _cache[48] || (_cache[48] = _createElementVNode("td", {
                    class: "cel",
                    "data-group": "true"
                  }, [
                    _createElementVNode("div", { class: "item" }, [
                      _createElementVNode("strong", null, "Battery_In_Charge")
                    ])
                  ], -1)),
                  _createElementVNode("td", _hoisted_150, [
                    _createElementVNode("div", _hoisted_151, _toDisplayString(realTimeData.value.battery_In_Charge), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})